<template>
  <div>TrangTaoChucVu</div>
</template>

<script>
export default {
  name: "TrangTaoChucVu"
};
</script>


